import React from "react";
import { useFormikContext } from "formik";
import { IQualificationEntity } from "models/Qualification.model";
import { useTranslation } from "react-i18next";
import { useStoreSelector } from "store/hooks";
import { selectLicensingClassesByQualificationName } from "store/domain-data/qualification-type/qualificationType";
import FlexBox from "components/FlexBox/FlexBox";
import ParticipantQualificationLicenseIdInput from "components/ParticipantEditDialog/ParticipantQualificationLicenseIdInput";
import { InputLabel } from "@mui/material";
import LicenseClassTag from "components/ParticipantEditDialog/qualification-forms/LicenseClassTag";

type DgpQualificationFormProps = {};

const LdgpQualificationForm: React.FC<DgpQualificationFormProps> = () => {
  const { values } = useFormikContext<IQualificationEntity>();
  const { t } = useTranslation();

  const licensingClasses = useStoreSelector((state) =>
    selectLicensingClassesByQualificationName(state, values.qualificationName)
  );

  return (
    <FlexBox direction={"column"} spacing={4}>
      <ParticipantQualificationLicenseIdInput isRequired={false} />
      <InputLabel>{t(`License Classes`)}</InputLabel>
      <FlexBox direction={"row"} spacing={2} flexWrap={"wrap"}>
        {licensingClasses.map((licenseClass) => (
          <LicenseClassTag key={licenseClass.id} displayName={licenseClass.displayName} name={licenseClass.name} />
        ))}
      </FlexBox>
    </FlexBox>
  );
};

export default LdgpQualificationForm;
